import {isInWeek} from '@/utils/utils'

const useShowPopup = (props: any) => {
  const {
    path,
    dispatch,
    loginInfo,
    firstShow,
    otherWebInPopupFirstShow,
    warningPopup,
  } = props;
  const body = document.getElementById('root');
  const beginTime = localStorage.getItem('pcPopBeginTime')
  
  const io = new IntersectionObserver((ioes) => {
    ioes.forEach((ioe) => {
      const el = ioe.target;
      const intersectionRatio = ioe.isIntersecting;
      if (intersectionRatio) {
        // loadImg(el)
        console.log('进入视野');
        if (ioe.boundingClientRect.width >= 540) {
          if(isInWeek(beginTime)){
            return 
          }
          dispatch({
            type: 'headInfo/changePcWarning',
            payload: true,
          });

        } else {
          if (
            loginInfo.login === false &&
            firstShow === true &&
            warningPopup === false && path === '/'
          ) {
            setTimeout(() => {
              console.log('headInfo:', loginInfo);
              dispatch({
                type: 'headInfo/changeinviteshow',
                payload: true,
              });
            }, 3000);
          }
        }
        io.unobserve(el);
      }
    });
  });
  // 执行交叉观察器
  function isInViewPortOfThree(el: any) {
    console.log('观察');
    io.observe(el);
  }
 
  isInViewPortOfThree(body);
};

export default useShowPopup;
